<template>
  <main class="home">
    <div class="play-btn">
      <div :class="['games-left', testPassed ? 'testPassed' : 'testFailed']">
        <br>
        <p v-if="testPassed">Test<br>has<br>Passed :)</p>
        <p v-else>Test<br>has NOT<br>Passed :(</p>
      </div>
    </div>
  </main>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import axios from 'axios';
import { ParseResponseMixin, GameMixin } from '@/common/mixins/game';
import webSocket from '@/common/webSocket';

export default {
  name: 'test-full-game-scenario',
  mixins: [ParseResponseMixin, GameMixin],
  data() {
    return {
      jwt: null,
      stompClient: null,
      testPassed: null,
      playerMsisdn: '',
      playerAnswerKey: '',
      availableAnswers: [],
      bothPlayersAnswered: false,
      personalizedData: null,
    };
  },
  created() {
    console.clear();
    console.log('in TestFullGameScenario created hook');
    this.playerMsisdn = this.$route.params.msisdn;
    console.log('playerMsisdn1:');
    console.log(this.playerMsisdn);
    this.stompClient = webSocket.createNewStompClient('/gameData');
    console.log(this.stompClient);
  },
  mounted() {
    this.findOpponent();
  },
  methods: {
    ...mapMutations('game', [
      'setPlayersCurrentQuestionDTOs',
      'setGameID',
      'setPlayersDetails',
    ]),
    findOpponent() {
      /* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
      console.log('creating a new web socket client');
      /* eslint-enable */
      const stompSuccess = (frame) => {
        console.log(`In OpponentFound component: ${frame}`);
        this.subscription = this.stompClient.subscribe(`/topic/gameFound/${this.playerMsisdn}`, (response) => {
          const responseData = JSON.parse(response.body);
          if (responseData.gameStateEnum === 'OPPONENT_FOUND') {
            console.log('newGameDTO.gameStateEnum === OPPONENT_FOUND');
            console.log('newGameDTO');
            this.saveResponseData(responseData);
            console.log('opponent found, going to next page...');
            this.webSocketConnectAndReceiveServerResponse();
          }
        }, (response2) => { // error callback
          console.log('response2');
          console.log(response2);
        });
        this.sendUserMsisdn();
      };
      const stompFailure = (error) => {
        console.error(`Connect failed with the following error: ${error.headers.message}`);
        connect();
      };
      // eslint-disable-next-line
      const connect = (() => {
        axios.post('/auth', {
          username: this.playerMsisdn,
          password: '123456a',
          rememberMe: false,
        }).then((response) => {
          // get body data
          this.jwt = response.data.token;
          console.log(`jwt fetched correctly for msisdn: ${this.playerMsisdn}`);
          this.stompClient.connect({ Authorization: this.jwt }, stompSuccess, stompFailure);
        }).catch((error) => {
          console.log(`Invoking callForAuthorization failed with the following error: ${error}`);
        });
      })();
    },
    sendUserMsisdn() {
      console.log(`sending user msisdn...: ${this.playerMsisdn}`);
      this.stompClient.send('/duel/randomMatching', { Authorization: encodeURIComponent(this.jwt) }, {});
    },
    saveResponseData(responseData) {
      this.setGameID(responseData.gameId);
      this.setPlayersDetails({
        homePlayerMSISDN: responseData.homeUserDetails.msisdn,
        homePlayerUsername: responseData.homeUserDetails.username,
        homePlayerAvatar: responseData.homeUserDetails.avatar,
        homePlayerLevel: responseData.homeUserDetails.currentLevel,
        awayPlayerMSISDN: responseData.awayUserDetails.msisdn,
        awayPlayerUsername: responseData.awayUserDetails.username,
        awayPlayerAvatar: responseData.awayUserDetails.avatar,
        awayPlayerLevel: responseData.awayUserDetails.currentLevel,
      });
    },
    webSocketConnectAndReceiveServerResponse() {
      console.log('inside webSocketConnectAndReceiveServerResponse method');
      this.stompClient.subscribe(`/topic/ctasFetched/${this.gameID}`, (response) => {
        console.log('INSIDE startGame subscription response');
        const newGameDTO = JSON.parse(response.body);
        if (newGameDTO.gameStateEnum === 'CTA_TO_BE_ANSWERED') {
          console.log('Themes fetched, saving received DTO');
          this.setPlayersCurrentQuestionDTOs({
            homePlayerQuestionDTO: newGameDTO.homeUserDetails.questionDTO,
          });
        }
      });
      this.stompClient.subscribe(`/topic/ctaSelected/${this.gameID}`, (response) => {
        console.log('Inside play: parsing response body data...');
        const responseBody = this.parseServerResponse(response.body);
        if (responseBody !== null) {
          const responseData = responseBody.data;
          console.log('responseData:', responseData);
          if (responseData.gameStateEnum === 'DISPLAY_CTA_TO_BE_ANSWERED' || responseData.gameStateEnum === 'SHOW_GAME_ROUND_END') {
            this.saveQuestionData(responseData);
          } else if (responseData.gameStateEnum === 'CTA_TO_BE_ANSWERED') {
            this.saveQuestionDataForNextQuestion(responseData);
            this.initQuestionData(responseData);
          } else if (responseData.gameStateEnum === 'SHOW_GAME_ROUND_END') {
            console.log('initializing question data...');
            console.log('this.currentQuestionNumber:', this.currentQuestionNumber);
            console.log('this.currentRoundNumber:', this.currentRoundNumber);
            console.log('DEBUGGING: 5');
          }
        }
      });
      console.info(`Subscribing to channel: /topic/categoriesFetched/${this.gameID}`);
      this.stompClient.subscribe(`/topic/categoriesFetched/${this.gameID}`, (response) => {
        console.log('[Game] Inside categoriesFetched response');
        // parse server response and return if any errors occur
        const responseData = this.parseServerResponse(response.body);
        if (responseData === null) {
          return;
        }
        console.log('responseData:', responseData);
        this.testPassed = false;
        if (responseData.gameStateEnum === 'GAME_FINISHED') {
          this.saveRoundData(responseData);
          console.log(`[Game] Finished with ID ${this.gameID}`);
          this.stompClient.unsubscribe();
          this.testPassed = true;
        }
      });
    },
    initQuestionData(responseData) {
      console.log('initializing question data...');
      console.log('this.currentQuestionNumber:', this.currentQuestionNumber);
      console.log('this.currentRoundNumber:', this.currentRoundNumber);
      // init common data
      this.playerAnswerKey = '';
      this.bothPlayersAnswered = true;
      this.personalizedData = this.isHomePlayer ? this.homePlayerQuestionDTO : '';
      this.sendAnswer(responseData);
    },
    sendAnswer(newGameDTO) {
      if (this.isHomePlayer) {
        console.log(`Home player answering 1 for question with id: ${newGameDTO.homeUserDetails.questionDTO.questionId}...`);
      } else {
        console.log(`Away player answering 3 for question with id: ${newGameDTO.homeUserDetails.questionDTO.questionId}...`);
      }
      this.sendUserAnswer(this.isHomePlayer ? newGameDTO.homeUserDetails.questionDTO.answerDTOList[1].answerKey : newGameDTO.awayUserDetails.questionDTO.answerDTOList[3].answerKey, newGameDTO.homeUserDetails.questionDTO.questionId);
    },
    sendUserAnswer(playerAnswerKey, questionId) {
      console.log('sending play data...');
      console.log('sending player answer');
      this.$axios({
        url: `api/sendSelectedCta2?gameId=${this.gameID}&answer=${playerAnswerKey}&questionID=${questionId}&useBoost=`,
        method: 'GET',
        headers: {
          Authorization: this.jwt,
        },
      }).catch((error) => {
        console.log(`Invoking api/sendSelectedCta2 failed with the following error: ${error}`);
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('game', [
      'numberOfQuestionsPerRound',
      'gameIsResuming',
      'gameID',
      'playersDetails',
      'currentRoundNumber',
      'currentQuestionNumber',
      'correctAnswerID',
      'homePlayerRoundScore',
      'homePlayerQuestionDTO',
      'homePlayerFiftyFiftyHelpUsed',
      'homePlayerAnswer',
      'homePlayerCorrectAnswersCSSClasses',
      'homeCorrectAnswers',
      'awayCorrectAnswers',
      'awayPlayerRoundScore',
      'awayPlayerCheatHelpUsed',
      'awayPlayerFiftyFiftyHelpUsed',
      'awayPlayerAnswer',
      'homePlayerLevel',
      'awayPlayerLevel',
      'awayPlayerLevelUpBonusPoints',
      'homePlayerLevelUpBonusPoints',
      'homePlayerGamesWon',
      'homePlayerGamesEarned',
      'awayPlayerGamesEarned',
      'awayPlayerGamesWon',
      'userLeveledUp',
    ]),
    ...mapGetters('game', [
      'isHomePlayer',
      'isGameWinner',
    ]),
  },
};
</script>

<style scoped>
  .testPassed {
    color: green;
  }
  .testFailed {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/stressTests/TestFullGameScenario.vue